import { SelectiveCorrectionFilter } from "../../../operations/filters/selectiveCorrection.js";
import { GLProgram } from "../../../program.js";
export class SelectiveCorrectionProgram extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var common_source = templates.get('photoshop/GL/shaders/common.glsl');
        var vertex_source = templates.get('photoshop/GL/shaders/filters/selectiveCorrection/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/filters/selectiveCorrection/fragment.glsl');
        var result = new SelectiveCorrectionProgram(gl, vertex_source, common_source + fragment_source);
        result._uniforms['texture'] = gl.getUniformLocation(result._program, 'u_texture');
        result._uniforms['texture_size'] = gl.getUniformLocation(result._program, 'u_texture_size');
        result._uniforms['use_selection'] = gl.getUniformLocation(result._program, 'u_use_selection');
        result._uniforms['selection_mask'] = gl.getUniformLocation(result._program, 'u_selection_mask');

        result._uniforms['useRelative'] = gl.getUniformLocation(result._program, 'u_useRelative');
        result._uniforms['redAdjust'] = gl.getUniformLocation(result._program, 'u_redAdjust');
        result._uniforms['yellowAdjust'] = gl.getUniformLocation(result._program, 'u_yellowAdjust');
        result._uniforms['greenAdjust'] = gl.getUniformLocation(result._program, 'u_greenAdjust');
        result._uniforms['cyanAdjust'] = gl.getUniformLocation(result._program, 'u_cyanAdjust');
        result._uniforms['blueAdjust'] = gl.getUniformLocation(result._program, 'u_blueAdjust');
        result._uniforms['magentaAdjust'] = gl.getUniformLocation(result._program, 'u_magentaAdjust');
        result._uniforms['whiteAdjust'] = gl.getUniformLocation(result._program, 'u_whiteAdjust');
        result._uniforms['neutralAdjust'] = gl.getUniformLocation(result._program, 'u_neutralAdjust');
        result._uniforms['blackAdjust'] = gl.getUniformLocation(result._program, 'u_blackAdjust');
        return result;
    }

    setUniforms(parameters: SelectiveCorrectionFilter) {
        var self = this;
        self._gl.uniform2f(self.uniformLocation('texture_size'), parameters._width, parameters._height);
        self._gl.uniform1i(self.uniformLocation('useRelative'), parameters.useRelative);
        self._gl.uniform4fv(self.uniformLocation('redAdjust'), parameters.redAdjust);
        self._gl.uniform4fv(self.uniformLocation('yellowAdjust'), parameters.yellowAdjust);
        self._gl.uniform4fv(self.uniformLocation('greenAdjust'), parameters.greenAdjust);
        self._gl.uniform4fv(self.uniformLocation('cyanAdjust'), parameters.cyanAdjust);
        self._gl.uniform4fv(self.uniformLocation('blueAdjust'), parameters.blueAdjust);
        self._gl.uniform4fv(self.uniformLocation('magentaAdjust'), parameters.magentaAdjust);
        self._gl.uniform4fv(self.uniformLocation('whiteAdjust'), parameters.whiteAdjust);
        self._gl.uniform4fv(self.uniformLocation('neutralAdjust'), parameters.neutralAdjust);
        self._gl.uniform4fv(self.uniformLocation('blackAdjust'), parameters.blackAdjust);
    }

}